import React, { useEffect } from 'react'
import "./SideModalTwo.css"

import largerlock from "../../images/large-lock.svg";
import bear from "../../images/bear.png";
import md1 from "../../images/modal2.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

function SideModalTwo() {
  return (
    <div className="onemodal-cont twomodal-cont">
      <div class="custom-box-wrapper">
        <svg class="custom-box-svg" viewBox="0 0 300 100" preserveAspectRatio="none">
          <polygon
            points="150,0 300,10 300,90 150,100 0,90 0,10"
            fill="#dbc3dc"
            stroke="#7a4fa3" 
            stroke-width="2"
            stroke-dasharray="2,2"
            vector-effect="non-scaling-stroke"
          />
        </svg>

        <div class="custom-box-content">
          <h6>Access your Complete Profile</h6>
          <p>Unlock the full results to find out which CARTOON CHARACTER perfectly matches your personality archetype</p>
          {/* <p>Unlock the full results to find out which CARTOON CHARACTER perfectly matches your personality archetype</p>
    <p>Unlock the full results to find out which CARTOON CHARACTER perfectly matches your personality archetype</p> */}
          <button>Get Detailed Report</button>
        </div>
        <img src={md1} alt="" />
        <img src={largerlock} alt="" />


      </div>



    </div>
  )
}

export default SideModalTwo